import React from 'react';

/**
 * Legacy, please use a HorizontalThrobber to indicate loading state instead.
 */
function LegacyCircularThrobber(): JSX.Element {
  return <div className="circular-throbber">Loading...</div>;
}

export default LegacyCircularThrobber;
